/*
 * @Author: your name
 * @Date: 2022-04-26 11:40:52
 * @LastEditTime: 2022-04-27 17:15:14
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/locales/loader.ts
 */
import { Locale } from 'antd/lib/locale-provider'

export enum LOCALES_KEYS {
    EN_US = 'en-US',
    ZH_CN = 'zh-CN'
}

export const SUPPOER_LOCALES = [
    {
        name: 'English',
        value: LOCALES_KEYS.EN_US
    },
    {
        name: '简体中文',
        value: LOCALES_KEYS.ZH_CN
    }
]

export interface LocaleResponse {
    localeData: StringObject
    antdLocaleData: Locale
}

export function getLocaleLoader(locale: string): Promise<LocaleResponse> {
    switch (locale) {
        case LOCALES_KEYS.ZH_CN:
            return new Promise(async resolve => {
                const loc = await import('./zh_CN.json').then(m => m.default)
                const antdLoc = await import('antd/lib/locale-provider/zh_CN').then(m => m.default)
                resolve({ localeData: loc, antdLocaleData: antdLoc })
            })
        default:
            return new Promise(async resolve => {
                const loc = await import('./en_US.json').then(m => m.default)
                const antdLoc = await import('antd/lib/locale-provider/en_US').then(m => m.default)
                resolve({ localeData: loc, antdLocaleData: antdLoc })
            })
    }
}
